import React, { Component } from 'react';
import '../App.scss';
import Select from 'react-select';


class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jurisdictions: [],

    }
    this.updateState = this.updateState.bind(this);
  }

  renderOptions(states) {
    let jurisdictions = this.props.jurisdictions;
    // let label = this.state.JusrisdictionName;
    return jurisdictions.map((state) => ({ value: state.jurisdiction, id: state.jurisdiction, label: state.jurisdictionName, key: state.jurisdiction, clearable: false })
    );
  }

  updateState(newValue) {
    // console.log(newValue);
    let stateCode = newValue.value;
    this.props.onSelectUSState(stateCode);
    if (this.props.storeFirstDropdownLabel) {
      this.props.storeFirstDropdownLabel(newValue.label);
    } else {
      if (this.props.storeSecondDropdownLabel) {
        this.props.storeSecondDropdownLabel(newValue.label);
      }  else {
        // console.log("must be map view");
      }
    }
  }

  selectDropdownOption(state) {
    // console.log(state);
    var stateCode = state.jurisdiction;
    this.props.onSelectUSState(stateCode);
  }
  render() {
    // console.log(this.state.jurisdictions);
    return (
      <div className="dropdown-container">
        <Select
          placeholder="I want to learn more about..."
          onChange={this.updateState}
          options={this.renderOptions(this.props.jurisdictions)}
          value={this.props.selectedUSState}
          clearable={false} />
      </div>
    );
  }

  fetchJurisdictions() {
    fetch(`${process.env.REACT_APP_API_URL}/api/licensing/jurisdictions`)
      .then(function (response) {
        return response.json();
      })
      .then((data) => {
        // console.log(data.Jurisdictions);
        const completedSurvey = data.Jurisdictions.filter(s => s.Completed === true);
        this.setState({
          jurisdictions: completedSurvey
        })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

}

export default Dropdown;


// WEBPACK FOOTER //
// ./src/components/Dropdown.js